import TwoUp from './TwoUp'

export default TwoUp
